



import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar } from '@syncfusion/ej2-react-richtexteditor';
import * as React from 'react';
import { registerLicense } from '@syncfusion/ej2-base';
import './TestComponent.css';


const CommentComponent = ({ title , onChange, textvalue}) => {
  const License_Key = 'Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH5ceXRQRmVdV0d+X0A=';
  registerLicense(License_Key);

  const toolbarSettings = {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',  'FontSize', 'FontColor', 'BackgroundColor', 'LowerCase', 'UpperCase', '|', 'Formats', 'Alignments', 'OrderedList', 'UnorderedList', 'Outdent', 'Indent', '|', 'CreateLink', 'Image', '|', 'ClearFormat', 'Print', 'SourceCode', 'FullScreen', '|', 'Undo', 'Redo'],
  };
  const quickToolbarSettings = {
    image: ['Replace', 'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-', 'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension'],
  };
  // const handleChange = (args) => {
  //   console.log('HANDLE CHANGE')
  //   console.log('HTML Content:', args.value);
  //   if (onChange ) {
  //     onChange(args.value);
  //   }
  // };
  const handleChange = (args) => {
    console.log('HANDLE CHANGE');
    const value = args.value || ''; // Use empty string if args.value is null
    console.log('HTML Content:', value);
    if (onChange) {
      onChange(value);
    }
  };
  // Event to apply default color
  // const handleEditorCreated = () => {
  //   const editor = document.querySelector('.custom-richtext-editor .e-content');
  //   if (editor) {
  //     editor.style.color = 'black';
  //   }
  // };

  return (
    <div className='App'>
      {title && <label htmlFor={name}>{title}</label>}
      {/* <div
        dangerouslySetInnerHTML={{
          __html: initialContent,
        }}
      ></div> */}

      <RichTextEditorComponent  toolbarSettings={toolbarSettings} quickToolbarSettings={quickToolbarSettings} change={handleChange} value={textvalue} cssClass='custom-richtext-editor'>
        <Inject services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar]} />
      </RichTextEditorComponent>
    </div>
  );
};

export default CommentComponent